import type { useTranslation } from 'react-i18next'
import type { ReturnRoot } from '@repo/sdk'
import { formatKrw } from '@repo/shared'

type TFunction = ReturnType<typeof useTranslation>['t']

/**
 * Display text for the server-decided return refund amount (`Return.refundAmount`).
 *
 * The amount is never computed here (서버 주도 UI 정책) — this only formats it and labels an
 * estimate (`isRefundAmountFinal` false: the refund is not issued yet). Returns `undefined`
 * when the server sent no amount, so callers omit it instead of computing one.
 */
export function formatReturnRefundAmount(
  t: TFunction,
  returnData: Pick<ReturnRoot, 'refundAmount' | 'isRefundAmountFinal'>,
): string | undefined {
  if (!returnData.refundAmount) return undefined
  const formatted = formatKrw(returnData.refundAmount.amount)
  return returnData.isRefundAmountFinal === false
    ? t('pages.returns.fields.estimatedAmount', { amount: formatted })
    : formatted
}
